import {LogicalWidgetEventStruct} from '../logical-widget-event.struct';
import {DeviceWidgetEnum} from '../../../../enums';

export class LogicalDeviceWidgetEventStruct extends LogicalWidgetEventStruct {
  public event_device_widget_type: DeviceWidgetEnum;
} // end Package
